module.exports = __webpack_public_path__ + "assets/img/btn-view-dbcb5bed.png";